import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column justify-center align-center",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "container my-4" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-12 col-md-10 col-lg-8" }
const _hoisted_6 = { class: "card mb-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-5" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-md-7" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "h5 fw-bold" }
const _hoisted_13 = { class: "text-secondary mb-3" }
const _hoisted_14 = { class: "text-secondary fw-bold" }
const _hoisted_15 = { class: "text-secondary fw-bold" }
const _hoisted_16 = { class: "card mb-4 border-primary" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-5" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "col-md-7" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "h5 fw-bold" }
const _hoisted_23 = { class: "text-secondary mb-3" }
const _hoisted_24 = { class: "text-secondary mb-4 fw-bold" }
const _hoisted_25 = { class: "text-secondary fw-bold" }
const _hoisted_26 = {
  key: 0,
  class: "price-alert"
}
const _hoisted_27 = { class: "card bg-light border mb-4" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "text-secondary small mb-0 ps-3" }
const _hoisted_30 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_31 = { class: "d-flex justify-content-between" }

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Subscription, { StripeInvoice, StripeUpcomingInvoice } from '../../../../../api/v2/models/subscription'
import { subscriptionState } from '../../../../stores/subscription'
import PremiumService, { SubscriptionCompare } from '../../../../../api/v2/models/pre_service'
import { format } from 'date-fns'
import { calcTaxIncluded } from '../../../../utils/price'
import { getQueryString } from '../../../../../../helpers/route-helper'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'PlanConfirm',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive state
const subscription = ref<Subscription | null>(new Subscription({}))
const stripeUpcomingInvoice = ref<StripeUpcomingInvoice | null>(null)
const stripeLastInvoice = ref<StripeInvoice | null>(null)
const targetPremiumService = ref<PremiumService | null>(null)
const subscriptionCompared = ref<SubscriptionCompare | null>(null)
const isLoading = ref(true)

// Computed properties
const targetPremiumServiceIdQuery = computed((): string | null => {
  return getQueryString(route.query, 'targetPremiumServiceId')
})

// Methods
const getSubscription = () => {
  subscriptionState.getSubscription(route.params.subscriptionId as any).then((response) => {
    if (response) {
      subscription.value = response.subscription
      if (subscription.value.isStoped) {
        window.location.href = '/classroom/subscription/' + subscription.value.id
      }
      stripeUpcomingInvoice.value = response.stripeUpcomingInvoice
      stripeLastInvoice.value = response.stripeInvoices[0]
    }
  })
}

const getTargetPremiumService = () => {
  subscriptionState.getTargetPremiumService(route.params.subscriptionId as any, targetPremiumServiceIdQuery.value as any).then((response) => {
    if (response) {
      targetPremiumService.value = response
      subscriptionCompared.value = response.subscriptionCompare
      isLoading.value = false
    }
  })
}

const submitChangePlan = () => {
  router.push(`/classroom/subscription/${route.params.subscriptionId}/change-plan/payment-confirm?targetPremiumServiceId=${targetPremiumService.value?.id}`)
}

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD')
}

const localNumber = (number: number) => {
  return new Intl.NumberFormat("ja-JP").format(number)
}

// Lifecycle
onMounted(() => {
  getSubscription()
  getTargetPremiumService()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_link = _resolveComponent("router-link")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          color: "green",
          size: "48"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4" }, "データを読み込んでいます。しばらくお待ちください...", -1 /* CACHED */))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"progress rounded-0\" data-v-17c318f4><div class=\"progress-bar bg-primary\" style=\"width:33%;\" data-v-17c318f4></div></div><div class=\"container mt-4\" data-v-17c318f4><div class=\"row justify-content-center\" data-v-17c318f4><div class=\"col-12 col-md-10 col-lg-8\" data-v-17c318f4><div class=\"d-flex justify-content-between\" data-v-17c318f4><div class=\"progress-step text-center\" data-v-17c318f4><div class=\"step-circle step-circle-active mx-auto\" data-v-17c318f4>1</div><small class=\"d-block mt-2 progress-step-active\" data-v-17c318f4>プランの確認</small></div><div class=\"progress-step text-center\" data-v-17c318f4><div class=\"step-circle mx-auto\" data-v-17c318f4>2</div><small class=\"d-block mt-2 text-secondary\" data-v-17c318f4>お支払い</small></div><div class=\"progress-step text-center\" data-v-17c318f4><div class=\"step-circle mx-auto\" data-v-17c318f4>3</div><small class=\"d-block mt-2 text-secondary\" data-v-17c318f4>完了</small></div></div></div></div></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: subscription.value.premiumServiceUrl,
                      class: "img-fluid w-100"
                    }, null, 8 /* PROPS */, _hoisted_9)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "h6 fw-bold mb-4" }, "現在のプラン", -1 /* CACHED */)),
                      _createElementVNode("h3", _hoisted_12, _toDisplayString(subscription.value.premiumServiceName), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_13, "契約更新日: " + _toDisplayString(stripeUpcomingInvoice.value ? dateFormat(new Date(stripeUpcomingInvoice.value.periodStart)) : '-'), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_14, "月額料金: ¥" + _toDisplayString(localNumber(_unref(calcTaxIncluded)(subscription.value && subscription.value.premiumServicePrice ? subscription.value.premiumServicePrice : 0))) + "（税込み）", 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_15, "入会金: ¥" + _toDisplayString(localNumber((subscription.value && subscription.value.needMembershipFee ? subscription.value.membershipFee : 0))) + "（税込み）", 1 /* TEXT */)
                    ])
                  ])
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-center my-4" }, [
                _createElementVNode("div", { class: "plan-change-arrow mx-auto" }, " ↓ ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("img", {
                      src: targetPremiumService.value.imageUrl,
                      class: "img-fluid w-100"
                    }, null, 8 /* PROPS */, _hoisted_19)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "h6 fw-bold mb-4" }, "変更後のプラン", -1 /* CACHED */)),
                      _createElementVNode("h3", _hoisted_22, _toDisplayString(targetPremiumService.value.name), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_23, "次回更新日: " + _toDisplayString(dateFormat(subscriptionCompared.value.targetPaymentAt)), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_24, "月額料金: ¥" + _toDisplayString(localNumber(targetPremiumService.value.price)) + "（税込み）", 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_25, "入会金: ¥" + _toDisplayString(localNumber((targetPremiumService.value.membershipFee))) + "（税込み）", 1 /* TEXT */),
                      (false && subscriptionCompared.value.targetPaymentTrialPrice > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 差額 ¥" + _toDisplayString(localNumber(subscriptionCompared.value.targetPaymentTrialPrice)) + "を次回請求時に加算させていただきます ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "h6 fw-bold mb-3" }, "プラン変更に関する注意事項", -1 /* CACHED */)),
                  _createElementVNode("ul", _hoisted_29, [
                    _cache[3] || (_cache[3] = _createElementVNode("li", { class: "mb-2" }, "プラン変更は即時反映されます", -1 /* CACHED */)),
                    (subscriptionCompared.value.targetPaymentTrialPrice > 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_30, "差額は次回請求時に加算されます"))
                      : _createCommentVNode("v-if", true),
                    _cache[4] || (_cache[4] = _createElementVNode("li", null, "契約更新日は変更されません", -1 /* CACHED */))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: `/classroom/subscription/${subscription.value.id}?tab=CHANGE_PLAN`,
                  class: "btn btn-light border px-4"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("キャンセル", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]),
                _createElementVNode("button", {
                  onClick: submitChangePlan,
                  class: "btn btn-primary px-4 text-white"
                }, "次へ進む")
              ])
            ])
          ])
        ])
      ]))
}
}

})